export const ToolsData = [
    { name: 'C#', bg: '#239120', fg: '#ffffff' },
    { name: '.NET Core', bg: '#512bd4', fg: '#ffffff' },
    { name: 'Entity Framework', bg: '#2f334d', fg: '#c0caf5', border: true },
    { name: 'Dapper', bg: '#2f334d', fg: '#c0caf5', border: true },
    { name: 'Node.js', bg: '#339933', fg: '#ffffff' },
    { name: 'JavaScript', bg: '#f7df1e', fg: '#1a1b26' },
    { name: 'React', bg: '#20232a', fg: '#61dafb' },
    { name: 'SQL', bg: '#336791', fg: '#ffffff' },
    { name: 'Docker', bg: '#2496ed', fg: '#ffffff' },
    { name: 'HTML5', bg: '#e34f26', fg: '#ffffff' },
    { name: 'CSS3', bg: '#1572b6', fg: '#ffffff' }
]
